<div class="form-group" [formGroup]="form">
  <input
    [id]="id"
    [name]="id"
    [value]="value"
    type="checkbox"
    [formControlName]="id"
    [checked]="checked"
    class="form-control"
    >
  @if (label) {
    <label
      [for]="id"
      class="form-label"
      >
      {{ label }}
    </label>
  }
</div>
